const defaultEpicFilterOptions = {
  epicCategories: {
    displayName: "Categories",
    values: [
      {
        displayName: "Dresses",
        id: "dress",
      },
      {
        displayName: "Gowns",
        id: "gowns",
      },
      {
        displayName: "Jumpsuits & Rompers",
        id: "jumpsuitsandrompers",
      },
      {
        displayName: "Tops",
        id: "tops",
      },
      {
        displayName: "Knits",
        id: "knits",
      },
      {
        displayName: "Pants",
        id: "pants",
      },
      {
        displayName: "Jeans",
        id: "jeans",
      },
      {
        displayName: "Shorts",
        id: "shorts",
      },
      {
        displayName: "Skirts",
        id: "skirts",
      },
      {
        displayName: "Jackets & Coats",
        id: "outerwear",
      },
      {
        displayName: "Blazers",
        id: "blazer",
      },
      {
        displayName: "Handbags",
        id: "handbags",
      },
      {
        displayName: "Jewelry",
        id: "jewelry",
      },
      {
        displayName: "Sunglasses",
        id: "sunglasses",
      },
    ],
  },
  colors: {
    displayName: "Color",
    values: [
      {
        displayName: "Black",
        id: "black",
      },
      {
        displayName: "Grey",
        id: "grey",
      },
      {
        displayName: "White",
        id: "white",
      },
      {
        displayName: "Off-White",
        id: "offwhite",
      },
      {
        displayName: "Brown",
        id: "brown",
      },
      {
        displayName: "Red",
        id: "red",
      },
      {
        displayName: "Orange",
        id: "orange",
      },
      {
        displayName: "Yellow",
        id: "yellow",
      },
      {
        displayName: "Green",
        id: "green",
      },
      {
        displayName: "Blue",
        id: "blue",
      },
      {
        displayName: "Purple",
        id: "purple",
      },
      {
        displayName: "Pink",
        id: "pink",
      },
      {
        displayName: "Multicolored",
        id: "multicolored",
      },
      {
        displayName: "Silver",
        id: "silver",
      },
      {
        displayName: "Gold",
        id: "gold",
      },
    ],
  },
  epicEmbellishments: {
    displayName: "Embellishments",
    values: [
      {
        displayName: "Cut-Outs",
        id: "cutouts",
      },
      {
        displayName: "Embroidery",
        id: "embroidered",
      },
      {
        displayName: "Lace",
        id: "lace",
      },
      {
        displayName: "Pleats",
        id: "pleats",
      },
      {
        displayName: "Pockets",
        id: "pockets",
      },
      {
        displayName: "Ruffles",
        id: "ruffles",
      },
      {
        displayName: "Sequins",
        id: "sequins",
      },
    ],
  },
  epicMaternity: {
    displayName: "Maternity",
    values: [
      {
        displayName: "Bump-Friendly",
        id: "bumpfriendly",
      },
      {
        displayName: "True Maternity",
        id: "truematernity",
      },
    ],
  },
  epicUseCaseEvents: {
    displayName: "Where to Wear It",
    values: [
      {
        displayName: "Everyday",
        id: "weekend",
      },
      {
        displayName: "Active & Lounge",
        id: "athleisure",
      },
      {
        displayName: "Work",
        id: "work",
      },
      {
        displayName: "Elevated Daytime",
        id: "daytimeevent",
      },
      {
        displayName: "Vacation",
        id: "vacation",
      },
      {
        displayName: "Date & Night Out",
        id: "datenightout",
      },
      {
        displayName: "Party",
        id: "party",
      },
      {
        displayName: "Black Tie",
        id: "formalaffair",
      },
      {
        displayName: "Wedding Guest",
        id: "weddingguest",
      },
      {
        displayName: "Bridesmaid",
        id: "bridesmaid",
      },
      {
        displayName: "For the Bride",
        id: "forthebride",
      },
    ],
  },
  epicStylePersonas: {
    displayName: "Styles",
    values: [
      {
        displayName: "Preppy",
        id: "classicpreppy",
      },
      {
        displayName: "Casual",
        id: "casuallaidback",
      },
      {
        displayName: "Bohemian",
        id: "bohochic",
      },
      {
        displayName: "Feminine",
        id: "feminineromantic",
      },
      {
        displayName: "Minimalist",
        id: "minimalist",
      },
      {
        displayName: "Eclectic",
        id: "eclectic",
      },
      {
        displayName: "Edgy",
        id: "edgy",
      },
    ],
  },
  epicPrint: {
    displayName: "Print",
    values: [
      {
        displayName: "No Print",
        id: "none",
      },
      {
        displayName: "Animal Print",
        id: "animalprint",
      },
      {
        displayName: "Floral",
        id: "floral",
      },
      {
        displayName: "Plaid & Check",
        id: "plaidcheck",
      },
      {
        displayName: "Stripe",
        id: "stripe",
      },
      {
        displayName: "Tie-Dye",
        id: "tiedye",
      },
    ],
  },
  epicSeasonality: {
    displayName: "Weather",
    values: [
      {
        displayName: "Warm",
        id: "springsummer",
      },
      {
        displayName: "Year-Round",
        id: "seasonless",
      },
      {
        displayName: "Cold",
        id: "fallwinter",
      },
    ],
  },
  epicFormality: "omit",
  epicSleeve: {
    displayName: "Sleeve",
    values: [
      {
        displayName: "Sleeveless",
        id: "sleeveless",
      },
      {
        displayName: "Cap Sleeve",
        id: "capsleeve",
      },
      {
        displayName: "Short Sleeve",
        id: "shortsleeve",
      },
      {
        displayName: "3/4 Sleeve",
        id: "34sleeve",
      },
      {
        displayName: "Long Sleeve",
        id: "longsleeve",
      },
    ],
  },
  epicLength: {
    displayName: "Length",
    values: [
      {
        displayName: "Mini",
        id: "mini",
      },
      {
        displayName: "Mid-Thigh Length",
        id: "midthigh",
      },
      {
        displayName: "Knee Length",
        id: "knee",
      },
      {
        displayName: "High Low",
        id: "highlow",
      },
      {
        displayName: "Midi",
        id: "midi",
      },
      {
        displayName: "Floor Length",
        id: "floor",
      },
    ],
  },
  epicNeckline: {
    displayName: "Neckline",
    values: [
      {
        displayName: "Boat",
        id: "boatneck",
      },
      {
        displayName: "Collared",
        id: "collared",
      },
      {
        displayName: "Cowl",
        id: "cowlneck",
      },
      {
        displayName: "Crew",
        id: "crewneck",
      },
      {
        displayName: "Halter",
        id: "halterneck",
      },
      {
        displayName: "High Neck",
        id: "highneck",
      },
      {
        displayName: "Mock Neck",
        id: "mockneck",
      },
      {
        displayName: "Off the Shoulder",
        id: "offtheshoulder",
      },
      {
        displayName: "One Shoulder",
        id: "oneshoulder",
      },
      {
        displayName: "Plunge",
        id: "plungeneck",
      },
      {
        displayName: "Scoop",
        id: "scoopneck",
      },
      {
        displayName: "Square",
        id: "squareneck",
      },
      {
        displayName: "Strapless",
        id: "strapless",
      },
      {
        displayName: "Sweetheart",
        id: "sweetheart",
      },
      {
        displayName: "Turtleneck",
        id: "turtleneck",
      },
      {
        displayName: "V-neck",
        id: "vneck",
      },
    ],
  },
};

export default defaultEpicFilterOptions;
export const {
  epicCategories,
  epicMaternity,
  epicUseCaseEvents,
  epicStylePersonas,
  epicEmbellishments,
  colors,
  epicPrint,
  epicFormality,
  epicSleeve,
  epicLength,
  epicNeckline,
} = defaultEpicFilterOptions;
